import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Button from "@/atomic/atoms/Button";
import Modal from "@/atomic/atoms/Modal";
import Loading from "@/atomic/atoms/Loading";

export default function PasswordView({
  goBack,
  submit,
  isDisabled,
  validatesNewPassword,
  isVisiblePassword,
  isVisibleNewPassword,
  toggleIsVisiblePassword,
  toggleIsVisibleNewPassword,
  isLoading,
  error,
  setError,
  success,
  goToLogin,
  refPassword,
  refNewPassword,
  onInput,
}: PropsView) {
  return (
    <div className="h-full">
      <Header
        title="Alterar senha"
        hasLeftButton
        goBack={goBack}
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={submit}>
          <div>
            <h2 className="mt-6 text-black text-xl">Alterar sua senha</h2>
            <h3 className="text-black text-sm">Informe seus dados nos campos abaixo</h3>
            <div className="flex flex-col justify-center items-center">
              <div className="flex flex-col w-full mt-3 relative">
                <input
                  ref={refPassword}
                  required
                  onInput={onInput}
                  type={isVisiblePassword ? "text" : "password"}
                  name="password"
                  placeholder="Sua senha atual"
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <button type="button" onClick={toggleIsVisiblePassword} className="absolute right-2 top-5">
                  <img
                    src={isVisiblePassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="flex flex-col w-full mt-3 relative">
                <input
                  ref={refNewPassword}
                  required
                  onInput={onInput}
                  type={isVisibleNewPassword ? "text" : "password"}
                  name="newPassword"
                  placeholder="Nova senha"
                  className="text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
                />
                <button type="button" onClick={toggleIsVisibleNewPassword} className="absolute right-2 top-5">
                  <img
                    src={isVisibleNewPassword ? "/eye-hidden.png" : "/icon-eye.png"}
                    width={24}
                    height={24}
                    alt="Visualizar senha"
                  />
                </button>
              </div>
              <div className="mt-1 bg-white w-full rounded-md p-2">
                {validatesNewPassword?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center justify-start">
                    <img
                      src={item.success ? "/icon-checked.png" : "/icon-unchecked.png"}
                      width={16}
                      height={16}
                      alt="ícone sucesso"
                      className="mr-2"
                    />
                    <p className="text-sm text-gray-400">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Button
            className="rounded-xl bg-primary text-white"
            title={"Avançar"}
            type="submit"
            isDisabled={isDisabled}
          />
        </form>
      </main>
      {error && <Modal
        title="Ops!"
        message="Houve um problema ao trocar sua senha, quer tentar novamente?"
        actionMessage="Tentar novamente"
        action={submit}
        actionSecondMessage="Não!"
        actionSecond={() => setError(false)}
      />}
      {success && <Modal
        title="Muito bem!"
        message="Sua senha foi alterada com sucesso. Realize o login novamente para continuar usando o Pedágio Eletrônico Sem Parar."
        actionMessage="Fazer Login"
        action={goToLogin}
      />}
      {isLoading && <Loading />}
    </div>
  );
}
